<template>
  <v-dialog persistent v-model="showShareSocialActionsPopup" max-width="450">
    <v-card max-width="450" class="mx-auto">
      <div class="px-3 pt-3 mb-n3 d-flex justify-end">
        <v-icon class="cursor-pointer" @click="closeShareSocialActionsPopup()"
          >mdi-close</v-icon
        >
      </div>
      <div class="share-social-container">
        <ShareNetwork
          v-for="network in networks"
          :network="network.network"
          :key="network.network"
          :style="{ backgroundColor: network.color }"
          :url="sharing.url"
          :title="sharing.title"
          :description="sharing.description"
          :quote="sharing.quote"
          :hashtags="sharing.hashtags"
          :twitterUser="sharing.twitterUser"
        >
          <v-icon class="mr-1 white--text">{{ network.icon }}</v-icon>
          <span>{{ network.name }}</span>
        </ShareNetwork>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ShowShareSocialActionsPopup",
  props: {
    showShareSocialActionsPopup: {
      type: Boolean,
      default: false,
    },
    sharing: {
      type: Object,
      default: function () {
        return {};
      },
    },
    networks: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    closeShareSocialActionsPopup() {
      this.$emit("closeShareSocialActionsPopup");
    },
  },
};
</script>

<style lang="scss" scoped>
.share-social-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 15px 0;
  a {
    padding: 3px 10px;
    margin: 5px;
    text-decoration: none;
    color: #fff;
    border-radius: 8px;
    i {
      color: #fff;
    }
  }
}
</style>
